import { Theme } from "@material-ui/core/styles";
import { makeStyles } from "@material-ui/core/styles";

export const PhotoUploaderStyles = makeStyles((theme: Theme) => ({
  container: {
    textAlign: "center",
    paddingRight: "30px",
    paddingLeft: "15px",
  },
  icon: {
    fontSize: "65px",
    color: "#232323",
    maxWidth: "100%", // Ensures the icon does not exceed the container's width
    overflow: "hidden", // Prevents overflow
  },
  input: {
    display: "none",
  },
  label: {
    cursor: "pointer",
    // paddingLeft: "1rem",
  },
  closeIconStyle: {
    stroke: "#000", // Adjust the color as needed
    strokeWidth: "2px", // Adjust the thickness as needed
    color: "#232323",
  },
  customFileUpload: {
    paddingLeft: "1rem",
  },
  span: {
    fontSize: "65px",
  },
  oddRow: {
    backgroundColor: "#F0F2F5",
  },
  evenRow: {
    backgroundColor: "#FFFFFF",
  },
  pageTitle: {
    fontFamily: " Oswald",
  },
  // hrTag: {
  //     border: theme.hrDashedStyle,
  // },
  hrWrapperOdd: {
    background: "linear-gradient(to bottom, #F0F2F5 50%, #FFFFFF 50%)",
  },
  hrWrapperEven: {
    background: "linear-gradient(to bottom, #FFFFFF 50%, #F0F2F5 50%)",
  },
  // hrTopTag: {
  //     border: theme.hrStyle
  // },
  marginLeft: {
    marginLeft: "5px",
  },
  selectPhoto: theme.custom.styles.headerTitle,
  selectPhotoDesc: theme.custom.styles.primaryDescription,
  vehInfoDetails: {
    ...theme.custom.styles.headerSub,
    marginBottom: ".5rem",
  },
  vehicleInfoLoc: {
    ...theme.custom.styles.linkText,
    textTransform: "none",
    textAlign: "left",
    marginTop: ".5rem",
    marginBottom: "0px !important",
    cursor: "pointer",
    "&:hover": {
      textDecoration: "underline",
    },
  },
  vehicleInfoLocHidden: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "26px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "white",
  },
  errorText: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "26px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#8A0200",
  },
  brandColorPhoneNumber: {
    color: theme.custom.colors.primaryColor,
  },
  regularText: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "26px",
    letterSpacing: "0em",
    textAlign: "left",
    color: "#232323",
  },
  dropZone: {
    alignSelf: "flex-end",
    background: "#F0F2F5",
    border: "2px dashed #ccc",
    borderRadius: "4px",
    paddingLeft: "2px !important",
    cursor: "pointer",
  },
  imagePreview: {
    paddingLeft: "5px",
    paddingRight: "5px",
    maxWidth: "100%",
    objectFit: "cover",
    padding: ".3rem",
    marginTop: "5px",
    width: "192px",
    height: "154px",
  },
  imagePreviewMobile: {
    paddingLeft: "5px",
    paddingRight: "5px",
    maxWidth: "100%",
    objectFit: "cover",
    padding: ".3rem",
    marginTop: "5px",
    width: "65px",
    height: "65px",
  },
  scrollPaper: {
    alignItems: "flex-start !important",
    marginTop: "400px",
  },
  imagePreviewSmall: {
    height: "auto",
    width: "auto!important",
    paddingLeft: "5px",
    paddingRight: "5px",
    maxWidth: "100%",
  },
  imagePreviewSmallOld: {
    width: "170px",
    height: "154px",
    left: "263px",
    top: "614px",
  },
  closebt: {
    paddingTop: "0px !important",
    fontFamily: "icomoon",
    fontSize: "28px",
    fontStyle: "normal",
    fontWeight: 400,
    lineHeight: "28px",
    letterSpacing: "0px",
    textAlign: "right",
  },
  rightButton: {
    display: "flex",
    alignContent: "center",
    fontWeight: "bold",
    fontSize: "24px",
    height: "24px",
    width: "24px",
    "$sizeSmall&": {
      marginRight: -1,
    },
  },
  imagePrevName: {
    alignItems: "center",
    justifyContent: "left",
    display: "flex",
    wordBreak: "break-word",
    width: "100%",
    paddingLeft: ".5rem",
  },
  imageName: {
    paddingLeft: "1rem",
    paddingRight: "25px",
    display: "flex",
    textAlign: "left",
    paddingBottom: "1rem",
    color: theme.custom.styles.secondaryDescription.color,
  },
  vinInfoPage: {
    position: "absolute",
    width: "600px",
    height: "566px",
    left: "320px",
    top: "200px",
    background: "#FFFFFF",
    borderRadius: "4px",
  },
  vinInfoIcon: {
    position: "absolute",
    width: "524px",
    height: "200px",
    left: "417px",
    top: "594px",
    background:
      "url(Screen Shot 2021-11-30 at 8.51.png), url(Screen Shot 2021-11-30 at 8.51.png), url(Screen Shot 2021-11-30 at 8.51.png)",
  },
  vinDesc: {
    fontFamily: "Open Sans",
    fontSize: "16px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "26px",
    letterSpacing: "0em",
    textAlign: "left",
  },
  vinInfoTitile: {
    leftMargin: "40px",
    fontFamily: "Open Sans",
    fontSize: "32px",
    fontStyle: "normal",
    fontWeight: 600,
    lineHeight: "48px",
    letterSpacing: "0em",
    textAlign: "left",
  },
  photoSelectInfo: {
    ...theme.custom.styles.headerSecondary,
    paddingTop: "20px !important",
    paddingBottom: "0px !important",
  },
  vehicleInfo: {
    ...theme.custom.styles.headerSecondary,
    paddingTop: "0px !important",
    textAlign: "left",
  },
  photoSelectHead: {
    ...theme.custom.styles.headerSecondary,
    marginTop: ".5rem",
  },
  photoInfoDetails: {
    ...theme.custom.styles.headerSub,
    paddingTop: "20px !important",
    paddingBottom: "0px !important",
  },
  impagePreviewSmall: {
    width: "128px",
    height: "157.59px",
    left: "267.38px",
    top: "1562.14px",
    marginTop: "25px",
    marginLeft: "10px",
  },
  multiSmallImage: {
    //position: "absolute",
    width: "210px",
    height: "114px",
    //left: "204px",
    top: "1962px",
    // alignContent: "left"
  },
  multiSmallImages: {
    width: "100%",
    height: "auto",
    maxWidth: "100%",
  },
  multiPhotos: {
    background: "#F0F2F5",
    border: "2px dashed #ccc",
    borderRadius: "4px",
    cursor: "pointer",
    "@media (max-width: 569px)": {},
  },
  multiplePhotos: {
    background: "#F0F2F5",
    border: "1px solid #656E7C",
    borderRadius: "2px",
    margin: "1px",
  },
  cBtnColor: {
    ...theme.custom.styles.linkButtonText,
    marginRight: "5px",
  },
  btnColor: {
    ...theme.custom.styles.submitButton,
  },
  btnSpan: {
    ...theme.custom.styles.rowSpan,
  },
  landpageHeader: {
    fontFamily: "Oswald",
    fontStyle: "normal",
    fontWeight: 600,
    fontSize: "32px",
    lineHeight: "44px",
    color: "#384252",
  },
  NextStepInfo: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: "28px",
    lineHeight: "26px",
    color: "#384252",
  },
  nextStepDesc: {
    fontFamily: "Open Sans",
    fontStyle: "normal",
    fontSize: "16px",
    lineHeight: "26px",
    color: "#384252",
    order: 0,
    alignSelf: "stretch",
    flexGrow: 1,
  },
  ctaRow: {
    "@media (max-width: 480px)": {
      flexDirection: "column-reverse",
      justifyContent: "center",

      "> button": {},
      "> a": {
        order: 2,
        marginBottom: "13px",
      },
    },
    //flexDirection: 'column-reverse',
    //justifyContent: 'center'
  },
  alignmentPadding: {
    "@media (max-width: 959px)": {
      paddingTop: "0px !important",
    },
    paddingTop: theme.custom.styles.hiddenPadding,
  },
  iconColor: {
    color: theme.custom.styles.iconColor,
  },
}));
